import { useEffect, useState } from 'react';
import {Col, Form, Row, Input, Modal, notification, InputNumber, Table} from 'antd';
import Button from '/react4xp/mixins/ui/button/button';

import { Space } from 'antd';
import {IShownComponents, IAnswerData} from '../express-help.types';
import BtnReturnBack from '../BtnReturnBack';
import Link from 'antd/es/typography/Link';
import EditQuestionnaireModal from '../modals/modal-edit-poll';
import React from 'react';
import {getRandomSecure} from "mixins/helpers";
import {createQuestion, getAnswersByQuestionId, getQuestionById} from "/react4xp/parts/express-help/actions";

// import {deleteOneById} from "../../../../../../../../../../build/resources/main/site/parts/express-help/actions";
const CreateQuestion = (props: any) => {
    const [form] = Form.useForm();
    const [createdQuestionId, setCreatedQuestionId] = useState<number>(null);

    const [selectedObject, setSelectedObject] = useState<IAnswerData>();
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const { confirm } = Modal;

    const moveToScreen = (nextScreenParameter: IShownComponents) => {
        props.showNext(nextScreenParameter);
    };

    const onFinish = async (values: any) => {
        values.username = props.user.login;
        values.questionnaireId = props.showObject.idOfQuestionnaire;
        values.externalQuestionId = Number.parseInt('' + getRandomSecure() * 100000000);

        createQuestion(values)
            .then((result) => {
                notification['info']({
                    message: 'Вопрос создан. Теперь можете добавлять ответ!',
                });

                setCreatedQuestionId(result.data.id);
            });
    };

    const [data, setData] = useState<IAnswerData[]>([]);

    const loadAnswers = () => {
        if (createdQuestionId) {
            getAnswersByQuestionId(createdQuestionId).then((response) => {
                setData(response.data);

                getQuestionById(props.showObject.idOfQuestion || createdQuestionId)
                    .then((response) => response.data)
                    .then((question_data) => {
                        form.setFieldValue('externalQuestionId', question_data.externalQuestionId);
                        form.setFieldValue('questionRu', question_data.questionRu);
                    });
            });
        }
    };

    const deleteOne = (id: number) => {
        confirm({
            title: 'Подтвердите действия удаления данных',
            onOk() {
                // deleteOneById(id, { service: 'Answer' })
                //     .then(() => {
                //         notification['success']({
                //             message: 'Данные успешно удалены!',
                //         });
                //         loadAnswers();
                //     })
                //     .catch(() => {
                //         notification['error']({
                //             message: 'Ошибка',
                //             description:
                //                 'Невозможно удалить запись. Требуется сначало удалить результаты ответа', //JSON.stringify(error),
                //         });
                //     });
            },
        });
    };

    const edit = (doc: any) => {
        setIsModalOpen(true);
        setSelectedObject(doc);
    };

    const onActionClick = (key: string, doc: any) => {
        switch (key) {
            case 'EDIT':
                edit(doc);
                break;
            case 'DELETE':
                deleteOne(doc.id);
                break;
        }
    };

    const handleOk = () => {
        setSelectedObject(null);
        setIsModalOpen(false);
        loadAnswers();
    };

    const handleCancel = () => {
        setSelectedObject(null);
        setIsModalOpen(false);
    };

    const columns = [
        {
            title: 'ИД',
            dataIndex: 'externalQuestionId',
        },
        {
            title: 'Ответ на казахском языке',
            dataIndex: 'answerKk',
        },
        {
            title: 'Ответ на русском языке',
            dataIndex: 'answerRu',
        },
        {
            title: 'Ответ на английском языке',
            dataIndex: 'answerEn',
        },
        {
            title: 'Изменил',
            dataIndex: 'username',
        },
        {
            title: 'Действия',
            width: 180,
            render: (text, record) => (
                <span>
                    <Link
                        className="column-button"
                        style={{ marginRight: 3 }}
                        onClick={() => {
                            onActionClick('DELETE', record);
                        }}
                    >
                        Удалить
                    </Link>

                    <Link
                        className="column-button"
                        style={{ marginRight: 3 }}
                        onClick={() => {
                            onActionClick('EDIT', record);
                        }}
                    >
                        Редактировать
                    </Link>
                </span>
            ),
        },
    ];

    useEffect(() => {
        loadAnswers();
    }, [createdQuestionId]);

    const onReturnBackHandler = () => {
        const nextPageParameter: IShownComponents = {
            mainPageShown: false,
            pollPageShown: false,
            questionPageShown: false,
            answerPageShown: false,
            editMode: props.showObject.editMode,
            pollItemPageShown: true,
            idOfQuestionnaire: props.showObject.idOfQuestionnaire,
            idOfQuestion: createdQuestionId || props.showObject.idOfQuestion,
        };

        props.showNext(nextPageParameter);
    };

    return (
        <div className="poll-screen">
            <BtnReturnBack handler={onReturnBackHandler} />

            <h4 className="my-3">Добавить вопрос</h4>

            <Form
                className="my-3"
                form={form}
                layout="vertical"
                onFinish={onFinish}
            >
                <Row gutter={{ xs: 8, md: 24 }}>
                    <Col span={24}>
                        <Form.Item
                            name="questionWeight"
                            label="Вес вопроса"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <InputNumber
                                placeholder="Введите"
                                max={999}
                                min={0}
                                defaultValue={0}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="questionKk"
                            label="Вопрос на казахском языке"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Input placeholder="Введите"/>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="questionRu"
                            label="Вопрос на русском языке"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Input placeholder="Введите" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="questionEn"
                            label="Вопрос на анг. языке"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Input placeholder="Введите" />
                        </Form.Item>
                    </Col>
                </Row>


                <Space wrap>
                    <Button onClick={onReturnBackHandler}>
                        Отменить
                    </Button>
                    <Button
                        type="primary"
                        htmlType="submit"
                        color="gold"
                    >
                        Сохранить
                    </Button>
                </Space>
            </Form>

            {createdQuestionId && (
                <Row gutter={{ xs: 24, md: 24 }} justify="space-between" className="my-3">
                    <Col>
                        <h4 className="express-help-list">Список ответов</h4>
                    </Col>
                    <Col>
                        <Button
                            disabled={!createdQuestionId}
                            color="gold"
                            onClick={() => {
                                moveToScreen({
                                    mainPageShown: false,
                                    pollPageShown: false,
                                    questionPageShown: false,
                                    answerPageShown: true,
                                    idOfQuestion: createdQuestionId,
                                    idOfQuestionnaire: props.showObject.idOfQuestionnaire,
                                    editMode: props.showObject.editMode,
                                });
                            }}
                        >
                            Добавить ответ
                        </Button>
                    </Col>
                </Row>
            )}

            {createdQuestionId && (
                <Table
                    className="my-3"
                    dataSource={data}
                    columns={columns}
                />
            )}

            <EditQuestionnaireModal
                isModalOpen={isModalOpen}
                handleOk={handleOk}
                handleCancel={handleCancel}
                selectedObject={selectedObject}
                selectedType={{ service: 'Answer' }}
            />
        </div>
    );
};

export default CreateQuestion;
